import { APIClient } from '../helpers/api_helper';
const AxiosClient = new APIClient()
const login = payload => AxiosClient.post('/auth/login',payload);
export {
  login,
}